import script from "./Traveller.vue?vue&type=script&lang=ts&setup=true"
export * from "./Traveller.vue?vue&type=script&lang=ts&setup=true"

import "./Traveller.vue?vue&type=style&index=0&id=37da1e65&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37da1e65"]])

export default __exports__